/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JpCoBenefitoneBsdpBffInfrastructureDtoOrderCacheCafeReservation
 */
export interface JpCoBenefitoneBsdpBffInfrastructureDtoOrderCacheCafeReservation {
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffInfrastructureDtoOrderCacheCafeReservation
     */
    cafeSubscriptionId?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffInfrastructureDtoOrderCacheCafeReservation
     */
    cafeMenuNo?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffInfrastructureDtoOrderCacheCafeReservation
     */
    cafeMenuBranchNo?: string;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffInfrastructureDtoOrderCacheCafeReservation
     */
    pointRate?: number;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffInfrastructureDtoOrderCacheCafeReservation
     */
    rounding?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffInfrastructureDtoOrderCacheCafeReservation
     */
    applyUnit?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffInfrastructureDtoOrderCacheCafeReservation
     */
    applyValue?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffInfrastructureDtoOrderCacheCafeReservation
     */
    cafeApplyNo?: string;
    /**
     * 
     * @type {boolean}
     * @memberof JpCoBenefitoneBsdpBffInfrastructureDtoOrderCacheCafeReservation
     */
    useCafeFlag?: boolean;
}

export function JpCoBenefitoneBsdpBffInfrastructureDtoOrderCacheCafeReservationFromJSON(json: any): JpCoBenefitoneBsdpBffInfrastructureDtoOrderCacheCafeReservation {
    return JpCoBenefitoneBsdpBffInfrastructureDtoOrderCacheCafeReservationFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsdpBffInfrastructureDtoOrderCacheCafeReservationFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsdpBffInfrastructureDtoOrderCacheCafeReservation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'cafeSubscriptionId': !exists(json, 'cafeSubscriptionId') ? undefined : json['cafeSubscriptionId'],
        'cafeMenuNo': !exists(json, 'cafeMenuNo') ? undefined : json['cafeMenuNo'],
        'cafeMenuBranchNo': !exists(json, 'cafeMenuBranchNo') ? undefined : json['cafeMenuBranchNo'],
        'pointRate': !exists(json, 'pointRate') ? undefined : json['pointRate'],
        'rounding': !exists(json, 'rounding') ? undefined : json['rounding'],
        'applyUnit': !exists(json, 'applyUnit') ? undefined : json['applyUnit'],
        'applyValue': !exists(json, 'applyValue') ? undefined : json['applyValue'],
        'cafeApplyNo': !exists(json, 'cafeApplyNo') ? undefined : json['cafeApplyNo'],
        'useCafeFlag': !exists(json, 'useCafeFlag') ? undefined : json['useCafeFlag'],
    };
}

export function JpCoBenefitoneBsdpBffInfrastructureDtoOrderCacheCafeReservationToJSON(value?: JpCoBenefitoneBsdpBffInfrastructureDtoOrderCacheCafeReservation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'cafeSubscriptionId': value.cafeSubscriptionId,
        'cafeMenuNo': value.cafeMenuNo,
        'cafeMenuBranchNo': value.cafeMenuBranchNo,
        'pointRate': value.pointRate,
        'rounding': value.rounding,
        'applyUnit': value.applyUnit,
        'applyValue': value.applyValue,
        'cafeApplyNo': value.cafeApplyNo,
        'useCafeFlag': value.useCafeFlag,
    };
}

